import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { ColorRing } from 'react-loader-spinner';
import QuestionsContainer from '../common/QuestionsContainer';
import { getRequest } from '../../requestUtils';
import { analyticsTrack } from '../../analyticsUtils';
import './AddLocationOnProposal.scss';
var renderSpinner = function renderSpinner() {
  return /*#__PURE__*/React.createElement(ColorRing, {
    visible: true,
    height: "20",
    width: "20",
    ariaLabel: "blocks-loading",
    wrapperStyle: {},
    wrapperClass: "updating-icon me-2",
    colors: Array(5).fill('#FFFFFF')
  });
};
var AddLocationOnProposal = /*#__PURE__*/function (_Component) {
  function AddLocationOnProposal(props) {
    var _this;
    _classCallCheck(this, AddLocationOnProposal);
    _this = _callSuper(this, AddLocationOnProposal, [props]);
    _this.state = {
      showModal: false,
      location: props.location,
      saveDisabled: false
    };
    _this.getLocation = _this.getLocation.bind(_this);
    _this.toggleModal = _this.toggleModal.bind(_this);
    _this.handleToggleSave = _this.handleToggleSave.bind(_this);
    return _this;
  }
  _inherits(AddLocationOnProposal, _Component);
  return _createClass(AddLocationOnProposal, [{
    key: "getLocation",
    value: function getLocation() {
      var _this2 = this;
      var _this$props = this.props,
        questionIds = _this$props.questionIds,
        questionableId = _this$props.questionableId,
        questionableType = _this$props.questionableType;
      this.setState({
        saveDisabled: true
      });
      getRequest("/question_answers/".concat(questionIds[0]), {
        questionable_id: questionableId,
        questionable_type: questionableType
      }).then(function (response) {
        analyticsTrack('Update location', {
          location: 'Proposal View'
        });
        _this2.setState({
          location: response.data.answer,
          showModal: false,
          saveDisabled: false
        });
      });
    }
  }, {
    key: "handleToggleSave",
    value: function handleToggleSave(saveDisabled) {
      this.setState({
        saveDisabled: saveDisabled
      });
    }
  }, {
    key: "toggleModal",
    value: function toggleModal() {
      this.setState(function (prevState) {
        return {
          showModal: !prevState.showModal
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        questionnaireName = _this$props2.questionnaireName,
        questionIds = _this$props2.questionIds,
        questionableId = _this$props2.questionableId,
        questionableType = _this$props2.questionableType,
        csrfToken = _this$props2.csrfToken,
        isOwner = _this$props2.isOwner;
      var _this$state = this.state,
        showModal = _this$state.showModal,
        location = _this$state.location,
        saveDisabled = _this$state.saveDisabled;
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide proposal-location mb-15 body-text-2"
      }, /*#__PURE__*/React.createElement(Modal, {
        dialogClassName: "proposal-location-modal",
        className: "style-guide",
        show: showModal,
        onHide: this.toggleModal
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(QuestionsContainer, {
        questionnaireName: questionnaireName,
        questionIds: questionIds,
        questionableId: questionableId,
        questionableType: questionableType,
        csrfToken: csrfToken,
        owner: isOwner,
        handleToggleSave: this.handleToggleSave
      }), /*#__PURE__*/React.createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "primary",
        onClick: this.getLocation,
        disabled: saveDisabled,
        className: "save-button ".concat(saveDisabled ? 'with-spinner' : '')
      }, saveDisabled && renderSpinner(), "Save")))), location ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-map-marker-alt me-3"
      }), location, ' ', /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: 0,
        onClick: this.toggleModal
      }, "(Update)")) : /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: 0,
        onClick: this.toggleModal
      }, "Enter current location"));
    }
  }]);
}(Component);
AddLocationOnProposal.propTypes = {
  location: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  questionnaireName: PropTypes.string.isRequired,
  questionIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  isOwner: PropTypes.bool.isRequired
};
AddLocationOnProposal.defaultProps = {
  location: null
};
export default AddLocationOnProposal;